import React from 'react';

type Visibility = 'auto' | 'hidden' | 'visible';

const VISIBILITY_STYLES = {
  auto: 'content-visibility-auto',
  hidden: 'content-visibility-hidden',
  visible: 'content-visibility-visible',
};

export const MobileContentVisibility = ({
  children,
  sizeY,
  visibility,
}: {
  children: React.ReactNode;
  sizeY?: number;
  visibility: Visibility;
}) => {
  return (
    <div
      className={`${VISIBILITY_STYLES[visibility]} sm:content-visibility-visible`}
      style={{
        containIntrinsicSize: `auto ${sizeY}px`,
      }}
    >
      {children}
    </div>
  );
};
